export const DOUBLE_ENTER_DEBOUNCE_MS = 550

export const createEnterPressTracker = () => ({ time: null, fieldKey: null })

export const isDuplicateEnterPress = (tracker, fieldKey, now = Date.now()) => {
  const { time, fieldKey: lastFieldKey } = tracker
  if (time && lastFieldKey === fieldKey && now - time < DOUBLE_ENTER_DEBOUNCE_MS) {
    tracker.time = now
    tracker.fieldKey = fieldKey
    return true
  }
  tracker.time = now
  tracker.fieldKey = fieldKey
  return false
}

export const blockIfDuplicateEnterKey = (keyCode, fieldKey, tracker, now = Date.now()) => {
  if (keyCode !== 13) return false
  return isDuplicateEnterPress(tracker, fieldKey, now)
}
